// Ableitung der Rollover-Restriktionen der Terminplanungs-Sidebar
// Setzt die Rollover-Restriktionen (Hin/Rück) anhand der bearbeiteten Ankunfts- und Abflugzeiten
export function applyRolloverRestrictions(flugdaten) {
  const [fruehesteAnkunft, spaetesteAnkunft] = flugdaten.find(
    item => item.label[0] === 'Hin: Früheste'
  ).valueEdited;
  const [fruehesterAbflug, spaetesterAbflug] = flugdaten.find(
    item => item.label[0] === 'Rück: Frühester'
  ).valueEdited;
  const restriktionenHinRolloverIndex = flugdaten.findIndex(
    item => item.label === 'Restriktionen Hin Rollover'
  );
  const restriktionenRueckRolloverIndex = flugdaten.findIndex(
    item => item.label === 'Restriktionen Rück Rollover'
  );

  if (fruehesteAnkunft != null && spaetesteAnkunft != null) {
    const compareFruehesteAnkunft = new Date().setHours(
      parseInt(fruehesteAnkunft.substring(0, 2)),
      parseInt(fruehesteAnkunft.substring(3, 5))
    );
    const compareSpaetesteAnkunft = new Date().setHours(
      parseInt(spaetesteAnkunft.substring(0, 2)),
      parseInt(spaetesteAnkunft.substring(3, 5))
    );

    if (compareFruehesteAnkunft >= compareSpaetesteAnkunft) {
      flugdaten[restriktionenHinRolloverIndex].valueEdited = true;
    } else {
      flugdaten[restriktionenHinRolloverIndex].valueEdited = false;
    }
  } else {
    flugdaten[restriktionenHinRolloverIndex].valueEdited = null;
  }

  if (fruehesterAbflug != null && spaetesterAbflug != null) {
    const compareFruehesterAbflug = new Date().setHours(
      parseInt(fruehesterAbflug.substring(0, 2)),
      parseInt(fruehesterAbflug.substring(3, 5))
    );
    const compareSpaetesterAbflug = new Date().setHours(
      parseInt(spaetesterAbflug.substring(0, 2)),
      parseInt(spaetesterAbflug.substring(3, 5))
    );

    if (compareFruehesterAbflug >= compareSpaetesterAbflug) {
      flugdaten[restriktionenRueckRolloverIndex].valueEdited = true;
    } else {
      flugdaten[restriktionenRueckRolloverIndex].valueEdited = false;
    }
  } else {
    flugdaten[restriktionenRueckRolloverIndex].valueEdited = null;
  }
}
